import { createMemo } from "solid-js"
import isEntityWaterWithCurrent from "../../lib/core/entity/isEntityWaterWithCurrent"
import isIdListSame from "../signal/equals/isIdListSame"
import createSharedCachedFactory from "./createSharedCachedFactory"
import { useSharedWaterEntsListMemo } from "./useSharedWaterEntsListMemo"

export const useSharedWaterEntsWithCurrentListMemo = createSharedCachedFactory((engine) => {
  const getWaterEntsList = useSharedWaterEntsListMemo(engine)

  const getWaterEntsWithCurrentList = createMemo(() => {
    const waterEnts = getWaterEntsList()
    return waterEnts.filter(isEntityWaterWithCurrent)
  }, [], {
    equals: isIdListSame,
  })

  return getWaterEntsWithCurrentList
})
